const img = (src, thumbnail) => ({
  src,
  thumbnail,
  thumbnailWidth: 175,
  thumbnailHeight: 175,
});

const allRelations = require.context(
  "../../assets/img/success/relations",
  true,
  /\.(jpe?g)$/i,
);

console.log(allRelations);

const buildGroup = subdir => {
  const prefix = `./${subdir}/`;
  const allKeys = new Set(
    allRelations.keys().filter(k => {
      const rel = k.slice(prefix.length);
      return k.startsWith(prefix) && !rel.includes("/");
    }),
  );
  const sources = [...allKeys]
    .filter(k => !/_icon\.[^.]+$/.test(k))
    .sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  return sources.map(k => {
    const iconKey = k.replace(/(\.[^.]+)$/, "_icon$1");
    return img(
      allRelations(k),
      allKeys.has(iconKey) ? allRelations(iconKey) : allRelations(k),
    );
  });
};

export const IMAGES_3101 = buildGroup("3101");
export const IMAGES_1402 = buildGroup("1402");
export const IMAGES_0703 = buildGroup("0703");
export const IMAGES_1403_1 = buildGroup("1403/1");
export const IMAGES_1403_2 = buildGroup("1403/2");
export const IMAGES_2803_1 = buildGroup("2803/1");
export const IMAGES_1104_1 = buildGroup("1104/1");
export const IMAGES_1104_2 = buildGroup("1104/2");
export const IMAGES_2504_1 = buildGroup("2504/1");
export const IMAGES_2504_2 = buildGroup("2504/2");
export const IMAGES_0905_1 = buildGroup("0905/1");
export const IMAGES_0905_2 = buildGroup("0905/2");
export const IMAGES_2305_1 = buildGroup("2305/1");
export const IMAGES_221124_1 = buildGroup("221124");
export const IMAGES_181125_1 = buildGroup("181125");

export const IMAGES_060326_1 = buildGroup("060326/1");
export const IMAGES_060326_2 = buildGroup("060326/2");
export const IMAGES_120326_1 = buildGroup("120326/1");
export const IMAGES_130326 = buildGroup("130326");
export const IMAGES_200326_1 = buildGroup("200326/1");
export const IMAGES_270326_1 = buildGroup("270326/1");
export const IMAGES_270326_2 = buildGroup("270326/2");

export const IMAGES_100426_1 = buildGroup("100426/1");
export const IMAGES_100426_2 = buildGroup("100426/2");
export const IMAGES_240426_1 = buildGroup("240426/1");
export const IMAGES_240426_2 = buildGroup("240426/2");
